import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';

import ShowMoreButton from '../ShowMoreButton';
import APIClient, { iterUnpack } from '../../services/APIClient';
import BrandPhotoCard from './BrandPhotoCard';
import Alert from '../Alert';
import {
  PATH_REGEX,
} from './Constants';

const BRAND_SLUG = document.getElementById('root').getAttribute('data-brand-slug');

export default class BrandDetailPhotos extends Component {
  constructor(props) {
    super(props);

    this.IS_BRAND_ADMIN = window.is_brand_admin === 'true';
    const brandDetails = iterUnpack(JSON.parse(window.props));
    const brandDetail = brandDetails.allBrands.length ? brandDetails.allBrands[0] : {};
    this.numberOfPhotos = 8;

    const newState = {
      brandSlug: BRAND_SLUG,
      photos: brandDetail.photos || [],
      photosCount: brandDetail.photosCount,
    };

    if (brandDetails.metadata.photos) {
      newState.metadata = {
        photos: brandDetails.metadata.photos,
      };
    }

    this.state = {
      ...this.defaultState(),
      ...newState,
    };
  }

  componentDidMount() {
    const { params } = this.props.match || {};
    const id = params.mediaItemAttributionId;

    if (id) {
      this.openPhotoModal(id);
    }

    this.props.history.listen((location, action) => {
      if (action === 'POP') {
        const matcher = location.pathname.match(`/photos/(${PATH_REGEX.ID})/`);
        if (matcher && matcher.length >= 1) {
          this.openPhotoModal(matcher[1]);
        }
      }
    });
  }

  openPhotoModal = (id) => {
    if (window.openBrandPhotoUniversalModal && id) {
      window.openBrandPhotoUniversalModal({
        ids: this.state.photos.map(photo => photo.mediaItemAttributionId),
        activeId: id,
        callSource: window.UNIVERSAL_MODAL.TYPE.BRAND_PHOTO,
        brandSlug: this.state.brandSlug,
        dispatcherPath: `/brands/${this.state.brandSlug}/photos/`,
      });
    }
  }

  fetchPhotosList = () => {
    this.setState({ isLoading: true });

    const query = `{
      allBrands(slug: "${this.state.brandSlug}") {
        edges {
          node {
            photos (
              first: ${this.numberOfPhotos},
              after: "${this.state.metadata.photos.endCursor || 0}",
            ) {
              ...photo
            }
          }
        }
      }
    }
    fragment photo on BrandPhotoNodeConnection{
      edges {
        node {
          mediaItemAttributionId
          url
        }
      }
      pageInfo{
        hasNextPage
        endCursor
      }
      totalCount
    }
  `;

    APIClient(query, true)
      .then((data) => {
        this.setState({
          photos: [...this.state.photos, ...data.allBrands[0].photos],
          metadata: data.metadata,
          isLoading: false,
        });
      });
  }

  defaultState = () => ({
    isLoading: false,
    brandSlug: null,
    photos: [],
    metadata: {
      photos: {
        hasNextPage: false,
        endCursor: 0,
      },
    },
    photosCount: 0,
  });

  render() {
    const {
      metadata, isLoading, photos, photosCount, brandSlug,
    } = this.state;
    const emptyMessage = this.props.emptyMessage || 'No Photos Available';

    return (
      <div className="row">
        <div className="pb-base columns small-12 flex-container align-justify">
          <h3 className="fs-m fw-medium">
            <i className="material-icons">image</i>
            {' '}
            Photos
          </h3>
          {this.IS_BRAND_ADMIN && this.props.allowAddition && (
          <a
            href={`/brands/${brandSlug}/photos/create`}
            className="button border-black black hover-blue hover-border-blue hollow fs-s"
          >
            Add New Photo
          </a>
          )}
        </div>
        <div className="columns small-12">
          {!photos || photos.length === 0
            ? <Alert type="secondary">{emptyMessage}</Alert>
            : <></>}
          <div className="row small-up-2 medium-up-4">
            {photos.map(photo => (
              <BrandPhotoCard
                onImageClick={this.openPhotoModal}
                key={photo.mediaItemAttributionId}
                brandSlug={brandSlug}
                photo={photo}
                ableToEdit={this.IS_BRAND_ADMIN}
              />
            ))}
          </div>
          <div className="row align-center pt-m">
            <ShowMoreButton
              showMoreHandler={this.fetchPhotosList}
              hasNextPage={metadata.photos ? metadata.photos.hasNextPage : false}
              isLoading={isLoading}
              remainingItems={photosCount - photos.length}
              text="View More Photos"
            />
          </div>
        </div>
        {!this.props.hideDivider
        && (
        <div className="columns small-12">
          <hr />
        </div>
        )}
      </div>
    );
  }
}

BrandDetailPhotos.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      selectedProductSlug: PropTypes.string,
      selectedMediaId: PropTypes.string,
      mediaItemAttributionId: PropTypes.string,
    }),
  }).isRequired,
  history: PropTypes.shape({
    location: PropTypes.shape({}).isRequired,
    listen: PropTypes.func,
  }).isRequired,
  emptyMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  allowAddition: PropTypes.bool,
  hideDivider: PropTypes.bool,
};

BrandDetailPhotos.defaultProps = {
  emptyMessage: null,
  allowAddition: true,
  hideDivider: false,
};
